<template>
  <layout-main-inner :title="envName">
    <layout-card-wrap hasHeaderSlot
      v-loading="loading">
      <template slot="title">
        <create-traceinfo-btn :envInfoType="envInfoType"
          :envName="envName"
          :fetch="fetchList" />
      </template>
      <template slot="form">
        <el-input :placeholder="'请输入' + envName + '名称'"
          v-model="config.envInfoName"
          style="width: 200px">
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
        :data="list">
        <el-table-column :label="envName + '名称'"
          width="300">
          <template slot-scope="{row}">
            <link-route :link-to="`${typeMap[envInfoType]}?vendorId=${row.vendorId}&envInfoId=${row.envInfoId}`">
              {{row.envInfoName}}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{row}">
            <image-list :fileList="row.envImage" />
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
          width="100">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-button type="text"
              @click="deletetracingenvinfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
          @current-change="handleCurrentChange"
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import ImageList from '@/components/public/image-list.vue'
import CreateTraceinfoBtn from './busi/create-traceinfo-btn.vue'
import { mapState } from 'vuex'
export default {
  name: 'trace-info-list',
  components: { ImageList, CreateTraceinfoBtn },
  props: {
    envInfoType: {
      type: Number,
      default: 1
    },
    envName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        envInfoName: '',
        vendorId: null
      },
      list: [],
      total: 0,
      typeMap: {
        1: '/plat-env-detail',
        2: '/breed-env-detail',
        3: '/work-env-detail'
      }
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('traceinfo/gettracingenvinfos', {
        payload: {
          ...this.config,
          envInfoType: this.envInfoType
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.envImage = item.envImage.split(',').map(o => ({ url: o }))
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deletetracingenvinfo (row) {
      this.$confirm(`此操作将永久删除该${this.envName}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('traceinfo/deletetracingenvinfo', {
            payload: {
              envInfoId: row.envInfoId,
              vendorId: row.vendorId
            },
            success: (res) => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  },
  created () {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
